/**
 * BrandMark — the HammerHead shark, the one place the brand is drawn.
 *
 * The mark is a raster master (`public/brand/mark-*.png`, derived from the
 * 2026-09-12 app icon; masters and the reproduction record live in
 * `docs/brand/`). It is ink on paper in the light face and paper on
 * graphite in the dark face, chosen by CSS so there is no hydration
 * flicker and no JS reading the theme. The `tile` variant is the app-icon
 * treatment: a black square with the paper mark, identical in both faces,
 * for the header where it must read as an icon rather than a glyph.
 */
import { cn } from "@/shared/lib/utils";

interface BrandMarkProps {
  /** `glyph` follows the face; `tile` is the app-icon square. */
  variant?: "glyph" | "tile";
  className?: string;
}

export function BrandMark({ variant = "glyph", className }: BrandMarkProps) {
  if (variant === "tile") {
    return (
      // eslint-disable-next-line @next/next/no-img-element -- static asset, no optimisation pass needed
      <img
        src="/icon.png"
        alt=""
        aria-hidden
        draggable={false}
        className={cn("size-6 select-none rounded-md border border-border", className)}
      />
    );
  }
  return (
    <span aria-hidden className={cn("relative inline-block size-5 select-none", className)}>
      {/* eslint-disable-next-line @next/next/no-img-element -- static asset */}
      <img src="/brand/mark-ink.png" alt="" draggable={false} className="absolute inset-0 size-full dark:hidden" />
      {/* eslint-disable-next-line @next/next/no-img-element -- static asset */}
      <img src="/brand/mark-paper.png" alt="" draggable={false} className="absolute inset-0 hidden size-full dark:block" />
    </span>
  );
}
